import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { IconTile } from '@/components/IconTile';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { Button } from '@/components/buttons';
import React from 'react';
export function Benefits() {
  const $ = _c(28);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["rewards"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("rewards:benefitsTile.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-10 whitespace-pre-wrap lg:mb-16" anchorKey="rewards.benefitsTile.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconTile icon={<IconRewards />} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("rewards:benefitsTile.box.1.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      icon: t3,
      title: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile icon={<IconRewards />} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link className="lg:text-xl" to={LINKS().registration} testId="rewardsBenefitsRegisterToPlus" analyticsParam="rewardsBenefitsRegisterToPlus" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = {
      icon: t6,
      title: <Trans t={t} i18nKey="rewards:benefitsTile.box.2.title">{t7}</Trans>
    };
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <BenefitTiles items={[t5, t8]} />;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = LINKS();
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = t10.registration;
  let t12;
  if ($[18] !== t) {
    t12 = t("rewards:benefitsTile.button");
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <Button to={t11} testId="rewardsBenefitsRegister" analyticsParam="rewardsBenefitsRegister" size="lg" variant="primary" align="center" className="mt-12 md:mt-14">{t12}</Button>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t9) {
    t14 = <div className="px-4">{t9}{t13}</div>;
    $[22] = t13;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14 || $[26] !== t2) {
    t15 = <section>{t2}{t14}</section>;
    $[25] = t14;
    $[26] = t2;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
}